<template>
  <div class="split-job-content-create">
    <common-card
      title="Groups (Qty Is inaccurate, only for reference!)"
      class="groups"
    >
      <div slot="header-ops" class="f-r-vc header-ops">
        <div @click="() => openGroupEdit()" class="f-r-c-c group-add">
          <svg-icon icon-class="new-group" />
          <span style="font-size: 14px">New Group</span>
        </div>
        <div @click="() => openRestGroupEdit()" class="f-r-c-c group-add">
          <svg-icon icon-class="new-group" />
          <span style="font-size: 14px">Rest As Group</span>
        </div>
      </div>
      <div class="group-list f-c">
        <div class="group-header f-r">
          <div class="table-row-status-indicator f-r">
            <svg-icon icon-class="lock" class="svg-lock" />
            <span class="status-title">Group Pallets On Hold</span>
          </div>
          <div class="table-row-status-indicator f-r">
            <svg-icon icon-class="important" class="svg-danger-color" />
            <span class="status-title">Rest Goods Group</span>
          </div>
        </div>
        <div class="f-r" style="gap: 10px; flex-wrap: wrap">
          <div
            class="group-item f-r-hsb f-r-vc hover-pointer"
            :class="{
              selected: item.name === curGroup,
              hold: item.hold === HOLD,
              rest: item.isRestGroup
            }"
            v-for="item in Object.values(goodsGroups)"
            :key="item.name"
            @click="onGroupClick(item.name)"
          >
            <svg-icon
              icon-class="lock"
              class="svg-lock"
              v-if="item.hold === HOLD"
            />
            <svg-icon
              class="rest-group-star"
              icon-class="important"
              v-if="item.isRestGroup === true"
            />
            <span class="title">{{ item.name }}</span>
            <svg-icon
              icon-class="pencil"
              class="modify hover-pointer"
              @click.native.prevent.stop="modifyGroup(item.name)"
            />
            <svg-icon
              icon-class="trash"
              class="delete hover-pointer"
              @click.native.prevent.stop="removeGroup(item.name)"
            />
          </div>
        </div>
      </div>
    </common-card>
    <div class="goods-selector">
      <div class="packing-list">
        <div class="header">
          <span class="title">
            Packing List (Qty is inaccurate, only for reference!)
          </span>
          <div class="right">
            <el-switch active-text="Hide Empty" v-model="hideUsedGoods" />
          </div>
        </div>
        <div class="content">
          <div>
            <el-input
              size="small"
              placeholder="Input cd to search"
              prefix-icon="el-icon-search"
              v-model="searchGoodsInput"
            >
            </el-input>
          </div>
          <div class="goods-list">
            <div
              class="good-item light-oswald"
              :class="{ empty: goods.leftover === 0 }"
              v-for="goods in filteredGoods"
              :key="goods.id"
            >
              <div class="left">
                <div class="first-row">{{ goods.sku }}</div>
                <div class="first-row">{{ goods.originGroup.riiOrderNo }}</div>
                <div class="second-row">
                  <span class="shiupment-method">{{
                    goods.shipmentMethod
                  }}</span>
                  <span class="shipment-no">{{ goods.shipmentNo }}</span>
                </div>
              </div>
              <div class="right">
                <span>Qty: {{ goods.leftover }} / {{ goods.quantity }}</span>
                <el-input-number
                  v-model="goods.assignCount"
                  size="small"
                  controls-position="right"
                  :disabled="goods.leftover === 0"
                  @change="() => {}"
                  :min="1"
                  :max="goods.leftover"
                />
                <el-button
                  size="small"
                  circle
                  class="button"
                  :disabled="goods.leftover === 0"
                  @click="() => addToGroup(goods)"
                >
                  <svg-icon icon-class="plus2" style="font-size: 15px" />
                </el-button>
                <el-button
                  size="small"
                  circle
                  class="button"
                  :disabled="goods.leftover === 0"
                  @click="() => addAllToGroup(goods)"
                >
                  <svg-icon icon-class="all" style="font-size: 18px" />
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="group-goods">
        <div class="header">
          <span>{{ curGroup || 'Please select a group' }}</span>
        </div>
        <div class="content goods-list" v-if="curGroup">
          <div
            class="good-item light-oswald"
            v-for="item in goodsGroups[curGroup].goods"
            :key="item.goods.id"
          >
            <div class="left">
              <div class="first-row">
                {{ item.goods.sku }}
              </div>
              <div class="second-row">
                <span class="shiupment-method">{{
                  item.goods.shipmentMethod
                }}</span>
                <span class="shipment-no">{{ item.goods.shipmentNo }}</span>
              </div>
            </div>
            <div class="right">
              <span style="font-weight: bold">Qty: {{ item.count }}</span>
              <el-button
                size="small"
                circle
                class="button"
                type="danger"
                @click="() => removeFromGroup(item.goods.id)"
              >
                <svg-icon
                  icon-class="trash"
                  class="svg-white-color"
                  style="font-size: 13px"
                />
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <goods-group-edit ref="newGroupDialog" />
  </div>
</template>

<script>
// components
import CommonCard from '@/components/common/CommonCard.vue'
import GoodsGroupEdit from '@/components/goods/GoodsGroupEdit.vue'
import isEmpty from 'lodash/isEmpty'
// models
import { HOLD, UNHOLD } from '@/core/models/constant'
// api
import { queryGoods } from '@/api/goods'

export default {
  name: 'SplitJobContentCreate',
  props: {
    groupsChanged: {
      type: Function,
      default: () => {}
    },
    goodsQuery: {
      type: Object,
      default: () => {}
    },
    palletGroups: {
      type: Array,
      default: () => []
    }
  },
  components: {
    CommonCard,
    GoodsGroupEdit
  },
  data() {
    return {
      HOLD,
      UNHOLD,
      hideUsedGoods: true,
      loadingData: false,
      curGroup: null,
      searchGoodsInput: '',
      packingList: [],
      goodsGroups: {
        ONT9: {
          addressId: 'ADDRESS-17c866b31937',
          goods: [],
          hold: 'False',
          name: 'ONT9',
          priority: 'Normal',
          isRestGroup: false
        }
      }
    }
  },
  watch: {
    goodsQuery: {
      handler() {
        if (!isEmpty(this.goodsQuery)) {
          this.fetchGoodsData()
        }
      },
      immediate: true
    }
  },
  computed: {
    filteredGoods() {
      return this.packingList.filter(one => {
        const isEmpty = this.hideUsedGoods && one.leftover === 0
        const hasText = one.sku.includes(this.searchGoodsInput)
        return !isEmpty && hasText
      })
    }
  },
  methods: {
    openGroupEdit(oldName = '', group) {
      this.$refs.newGroupDialog.open(group, (values, done, error) => {
        const [flag, msg] = this.saveGroupEdit(oldName, values)
        if (flag) done()
        else error(msg)
      })
    },
    openRestGroupEdit(oldName = '', group) {
      this.$refs.newGroupDialog.open(group, (values, done, error) => {
        const [flag, msg] = this.saveGroupEdit(oldName, values, true)
        if (flag) done()
        else error(msg)
      })
    },
    saveGroupEdit(oldName, group, restFlag = false) {
      const [passed, err] = this.groupValidation(group, oldName)
      if (!passed) return [passed, err]
      if (oldName !== '') {
        const old = this.goodsGroups[oldName]
        this.$set(this.goodsGroups, group.name, { ...old, ...group })
      } else {
        let goods = []
        if (restFlag) {
          // put rest into group
          goods = this.packingList
            .filter(one => one.leftover > 0)
            .map(goods => {
              const count = goods.leftover
              goods.leftover = 0
              return { goods, count }
            })
        }
        this.$set(this.goodsGroups, group.name, {
          ...group,
          goods,
          isRestGroup: restFlag
        })
      }
      this.onGroupClick(group.name)
      return [true, '']
    },
    modifyGroup(groupName) {
      this.openGroupEdit(groupName, this.goodsGroups[groupName])
    },
    groupValidation(newGroup, oldName) {
      if (newGroup.name !== oldName && newGroup.name in this.goodsGroups) {
        return [false, 'Same group already exists!']
      }
      return [true, '']
    },
    onGroupClick(groupName) {
      this.curGroup = groupName
    },
    addAllToGroup(goods) {
      goods.assignCount = goods.leftover
      this.addToGroup(goods)
    },
    addToGroup(goods) {
      if (!this.curGroup) {
        this.$message.error('Please choose a group')
        return
      }
      const group = this.goodsGroups[this.curGroup]
      const goodsIndex = group.goods.findIndex(one => one.goods.id === goods.id)
      if (goodsIndex > -1) {
        group.goods[goodsIndex].count += goods.assignCount
      } else {
        group.goods.push({
          goods,
          count: goods.assignCount
        })
      }
      goods.leftover = goods.leftover - goods.assignCount
      goods.assignCount = 1
    },
    removeFromGroup(goodsId) {
      if (!this.curGroup) {
        this.$message.error('Please choose a group')
        return
      }
      const group = this.goodsGroups[this.curGroup]
      const goodsIndex = group.goods.findIndex(one => one.goods.id === goodsId)
      if (goodsIndex > -1) {
        const item = group.goods[goodsIndex]
        item.goods.leftover += item.count
        group.goods.splice(goodsIndex, 1)
      }
    },
    removeGroup(groupName) {
      this.$confirm(`Remove group ${groupName}, Continue?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          const group = this.goodsGroups[groupName]
          if (group) {
            group.goods.forEach(item => {
              item.goods.leftover += item.count
            })
            if (this.curGroup === groupName) {
              this.curGroup = null
            }
            this.$delete(this.goodsGroups, groupName)
          }
        })
        .catch(() => {})
    },
    async fetchGoodsData() {
      if (!isEmpty(this.goodsQuery)) {
        this.loadingData = true
        const page = await queryGoods({
          ...this.goodsQuery,
          size: -1
        })
        // find order for each goods
        const a = (page?.records ?? []).map(goods => {
          const originGroup = this.palletGroups.find(group =>
            group.goodsIds.includes(goods.id)
          )
          return {
            ...goods,
            originGroup,
            leftover: goods.quantity,
            assignCount: 1
          }
        })
        this.$set(this, 'packingList', a)
        this.loadingData = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/common.scss';
.split-job-content-create {
  .groups {
    .header-ops {
      gap: 10px;
    }
    .group-add {
      font-size: $title-level-one;

      svg {
        filter: $svg-business-color;
      }

      &:hover {
        cursor: pointer;
        color: $business-color;
      }
    }

    .group-list {
      gap: 10px;
      min-height: 40px;
      margin-bottom: 10px;

      .group-header {
        gap: 20px;
      }

      .group-item {
        gap: 10px;
        border-radius: 3px;
        padding: 10px 20px;
        background-color: rgba($color: $business-color, $alpha: 0.1);

        .title {
          word-break: break-word;
          font-size: $title-level-three;
          font-weight: bold;
          margin-right: 10px;
          font-family: 'oswald bold', sans-serif;
        }

        .delete:hover,
        .split:hover,
        .modify:hover {
          filter: $svg-danger-color !important;
        }

        &.selected {
          color: white;
          background-color: rgba($business-color, 0.9) !important;

          .svg-icon {
            filter: $svg-white;
          }
        }

        &.hold {
          color: white;
          background-color: rgba($deep-warning, 0.9);
        }

        &:hover {
          background-color: rgba($business-color, 0.3);
        }

        .rest-group-star {
          filter: $svg-danger-color !important;
        }
      }
    }
  }
  .goods-selector {
    display: flex;
    flex-direction: row;
    gap: 20px;
    @extend .common-card-margin;
    .packing-list,
    .group-goods {
      width: calc(50% - 10px);
      background-color: white;
      border-radius: $home-card-border-radius;
      @extend .shadow-level-three;
      .header {
        font-weight: bold;
        border-bottom: 1px solid #e4e7ed;
        @extend .common-card-padding;
      }
      .content {
        height: 400xp;
        @extend .common-card-padding;
      }
    }

    .packing-list {
      .header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
}
.goods-list {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 300px;
  padding-right: 4px;
  overflow-x: hidden;
  overflow-y: auto;
  .good-item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 16px;
    border-radius: 4px;
    border: 1px solid #e4e7ed;
    &.empty {
      background-color: $global-background-color;
      cursor: not-allowed;
    }
    @extend .common-card-padding;

    @extend .f-c;

    flex-wrap: wrap;

    .second-row {
      gap: 10px;
      font-size: $secondary-body-font-size;
      @extend .f-r-vc;
    }

    .right {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 5px;

      .el-input-number {
        width: 100px;
      }

      .button {
        width: 26px;
        height: 26px;
        padding: 2px;
        margin: 0px;
      }
    }
  }

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: #ada9a9;
  }
}
</style>
